/**
 * Panagroteh custom front-end enhancements.
 * Loaded globally via snippets/stylesheets.liquid (deferred).
 */

/**
 * Mega-menu hover reliability.
 *
 * The theme only opens a top-level dropdown when a `pointerenter` fires on the
 * menu item's <li> itself (see blocks/_header-menu.liquid: `on:pointerenter`).
 * If you land directly on the link text, cross the small physical gap between
 * the bar and the panel, or move fast, that specific enter can be missed and the
 * dropdown never opens (or flickers shut).
 *
 * `pointerover` bubbles from any descendant, so we re-assert "open" whenever the
 * pointer is over a menu item — or over its already-open panel, which is a DOM
 * descendant of the same <li>. We only act when the item is currently closed, so
 * this is cheap and never fights the theme. Closing stays entirely the theme's
 * job. Desktop only (the drawer handles mobile).
 */
(function initMegaMenuHoverFix() {
  const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

  document.addEventListener(
    'pointerover',
    (event) => {
      if (!isDesktop()) return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      const item = target.closest('.menu-list__list-item:not([slot="overflow"])');
      if (!item) return;

      // Already open? Leave it — the theme keeps it open and handles closing.
      const link = item.querySelector('[aria-expanded]');
      if (link && link.getAttribute('aria-expanded') === 'true') return;

      // Re-dispatch the enter the theme expects, on the <li> itself, so the
      // dropdown opens regardless of where or how fast the pointer arrived.
      item.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
    },
    { capture: true }
  );
})();
